const RELOADED_AT_KEY = "amazing-care.stale-deploy-reload";
/** Long enough that a real outage shows the error page instead of reloading forever. */
const RELOAD_GUARD_MS = 60_000;

// Chromium, Firefox and Safari word a failed dynamic import differently; a
// missing chunk can also come back as index.html, which fails on its MIME type.
const STALE_CHUNK_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|is not a valid JavaScript MIME type/i;

/**
 * True when a page's code failed to load, which after a deploy means this tab
 * still runs the previous build and asks for chunks that no longer exist.
 */
export function isStaleChunkError(error: unknown): boolean {
  return error instanceof Error && STALE_CHUNK_ERROR.test(error.message);
}

function lastReloadAt(): number {
  try {
    return Number(window.sessionStorage.getItem(RELOADED_AT_KEY)) || 0;
  } catch {
    return 0;
  }
}

/** Whether a reload may be tried now: once per minute, so a real outage cannot loop. */
export function canReloadForNewDeploy(now = Date.now()): boolean {
  return now - lastReloadAt() > RELOAD_GUARD_MS;
}

/** Reloads onto the current build. Returns false when it already tried within the last minute. */
export function reloadForNewDeploy(now = Date.now()): boolean {
  if (!canReloadForNewDeploy(now)) return false;
  try {
    window.sessionStorage.setItem(RELOADED_AT_KEY, String(now));
  } catch {
    // Without storage there is no loop guard, so do not reload at all.
    return false;
  }
  window.location.reload();
  return true;
}
